require('./components/geolocation');
require('./components/header');
require('./components/lazysizes');
require('./components/footer');
require('./components/color-button');